import React from 'react';

import get from 'lodash.get';
import MaskedInput from 'react-text-mask';

import FieldWrapper from '../../../components/common/formElements/fieldWrapper';

class MaskedColoredInputField extends React.Component {
    MaskedInputRef;

    componentDidMount() {
        if (!this.props.autoFocus) {
            return;
        }

        const inputElement = get(this.MaskedInputRef, 'inputElement');

        if (inputElement) {
            inputElement.focus();
            if (inputElement.value !== null && inputElement.value !== undefined) {
                inputElement.selectionStart = inputElement.value.length;
                inputElement.selectionEnd = inputElement.value.length;
            }
        }
    }

    onChange = () => {
        const value = get(this.MaskedInputRef, 'inputElement.value');

        this.props.onChange(value);
    }

    render() {
        const { id, mask, value, label, validation, error, errorMessage, onBlur, inputSub, popup, labelColor, inputLabel } = this.props;

        return (
            <FieldWrapper label={label}
                validation={validation}
                error={error}
                errorMessage={errorMessage}
                onBlur={onBlur}
                inputSub={inputSub}
                popup={popup}
                value={value}>
                <div className="ui labeled input">
                    <div className="ui label label" style={{ backgroundColor: labelColor, color: 'white' }}>{inputLabel || "$"}</div>
                    <MaskedInput id={id}
                        inputMode="numeric"
                        onChange={this.onChange}
                        value={value}
                        mask={mask}
                        type={"text"}
                        pattern="[0-9]*"
                        ref={(input) => { this.MaskedInputRef = input }}
                    />
                </div>
            </FieldWrapper>
        );
    }
}

export default MaskedColoredInputField;
